export default __webpack_public_path__ + "static/cndf-cilium-clustermesh2-55fab7bb34d61dedf80bcf2d16c5ba41.jpg";